import SellerBrowsePortfolio from './SellerBrowsePortfolio.page';

export default SellerBrowsePortfolio;